import { Stack, styled } from "@mui/material";

export const StoreUsersContainer = styled(Stack)``;
